import { render, staticRenderFns } from "./SeparateFileSelectTable.vue?vue&type=template&id=4f1d0cbf&scoped=true&lang=pug"
import script from "./SeparateFileSelectTable.vue?vue&type=script&lang=ts"
export * from "./SeparateFileSelectTable.vue?vue&type=script&lang=ts"
import style0 from "./SeparateFileSelectTable.vue?vue&type=style&index=0&id=4f1d0cbf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1d0cbf",
  null
  
)

export default component.exports